/**
 * ブランドLP、一社請求LP用 教室地図モーダルメソッド
 * 
 * 下記エレメントからのみ呼び出すこと
 * site/View/Themed/PC/Elements/contents/brand_lp/kousha_map_modal.tpl
 */

/**
 * 教室地図モーダルのイベントを登録する
 * モーダル開閉、地図読み込み、スクロール制御を実行
 */
function registMapModalAction() {
	// クラスやセレクターの変数
	const classNameModalWindow = "js-kousha-map-modal-window";
	const classNameModalWindowBox = "js-kousha-map-modal-window-box";
	const classNameModalWindowInner = "js-kousha-map-modal-window-box-inner";
	const classNameModalWindowMapCanvas = "js-kousha-map-modal-map-canvas";
	const selectorToHide = ".js-scroll-header, .js-follow-btn";

	const selectorModalOpen = ".js-kousha-map-modal-open";
	const selectorModalClose = ".js-kousha-map-modal-window .js-kousha-map-modal-window-close, .js-kousha-map-modal-window .js-kousha-map-modal-window-box";
	// 非表示にしたエレメント配列。再表示用に格納する。
	let toggleElements;

	// モーダルを開く
	$(document).on('click', selectorModalOpen, function () {
		let koushaId = $(this).attr('data-kousha_id');
		// 対象のモーダルを設定
		const modalArea = $('.' + classNameModalWindow + '[data-kousha_id="' + koushaId + '"]');
		_modalOpen(modalArea);
	});

	// モーダルを閉じる
	$(document).on('click', selectorModalClose, function () {
		const modalArea = $(this).parents('.' + classNameModalWindow);
		_modalClose(modalArea);
	});

	/**
	 * モーダルを開く処理
	 * スクロール停止、地図読み込み、オーバーレイ表示を実行
	 */
	function _modalOpen(modalArea) {
		// 対象のモーダルを設定
		const modalOverlay = modalArea.find('.' + classNameModalWindowBox);
		const modalInner = modalArea.find('.' + classNameModalWindowInner);

		// スクロールを止める。
		_lockScroll();

		// マップを読み込む
		_loadingMap(modalArea)

		// オーバレイ表示
		modalOverlay.fadeIn("fast");

		// 不要なエレメントを非表示
		_hideOtherElement();

		// モーダルの表示
		modalInner.fadeIn("fast");
	}

	/**
	 * モーダルを閉じる処理
	 * オーバーレイ非表示、要素再表示、スクロール解放を実行
	 */
	function _modalClose(modalArea) {
		// 対象のモーダルを設定
		const modalOverlay = modalArea.find('.' + classNameModalWindowBox);
		const modalInner = modalArea.find('.' + classNameModalWindowInner);

		// クリックしたボタンと同じ要素のモーダルウィンドウを閉じる
		modalOverlay.fadeOut();
		modalInner.fadeOut();
		// 不要なエレメントを再表示
		_showOtherElement();
		// スクロールを元に戻す
		_unlockScroll();
	}

	/**
	 * スクロールを固定する
	 * 現在のスクロール位置を保存してbodyのスクロールを無効化
	 */
	function _lockScroll() {
		currentScrollY = $(window).scrollTop();
		$('body').css('min-height', '100vh');
		$('body').css('overflow', 'hidden');
	}

	/**
	 * スクロールの固定を解除する
	 * 保存したスクロール位置に復元
	 */
	function _unlockScroll() {
		$('body').css('min-height', '');
		$('body').css('overflow', '');
		$(window).scrollTop(currentScrollY);
	}


	/**
	 * モーダル表示時に不要な要素を非表示にする
	 * 非表示にした要素を配列に保存
	 */
	function _hideOtherElement() {
		toggleElements = $(selectorToHide).filter(':visible');
		toggleElements.hide();
	}

	/**
	 * 非表示にした要素を再表示する
	 * 保存した要素配列を使用して表示
	 */
	function _showOtherElement() {
		toggleElements.show();
	}

	/**
	 * 地図情報を読み込む
	 * 未読み込みの場合のみ地図を初期化して表示
	 */
	function _loadingMap(mapModal) {
		const mapModalDisp = mapModal.find('.' + classNameModalWindowMapCanvas)[0];

		// マップが読み込まれていない場合のみ読み込む
		if(mapModal.attr("data-loaded-map") != "1"){
			const lat = mapModal.attr("data-kousha_lat");
			const lon = mapModal.attr("data-kousha_lon");
			const mapModalCommon= new MapModalCommon(mapModalDisp, lat, lon);
			mapModalCommon.loadKoushaMapDefaultPc();
			mapModal.attr("data-loaded-map", "1");
		}
	}
}

$(function(){
	registMapModalAction();
})